import { useState, useEffect, useRef, Fragment, memo, useMemo } from "react";
import style from "./../index.module.scss";
import styleUi from "./OptionSelector.module.scss";
import allStyle from "./../../comm/global/all.module.scss";
import { v4 } from "uuid";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';
import * as YStyle from "../../Styleds";
import SelectTime from "../../comm/global/components/SelectTime";
import SelectOption from "../../comm/global/components/SelectOption";

const OptionSelector = ({ setModalType, arg, addModalType }) => {
    const [inProp, setInProp] = useState(false);
    const [data, setData] = useState({ hr: 0, min: 0 });
    useEffect(() => {
        setInProp(true);
        if(arg.type==="option")
            setData(arg.list[0])
    }, [])

    
   
    return (
        <div className={style.modalBottom}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.UpPageEnterActive,
                enterDone: style.UpPageEnterDone,
                exitActive: style.UpPageExit,
                exitDone: style.UpPageExitActive
            }}
            >
                <div className={`${style.UpPage}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "OptionSelector"))
                        }}
                    >
                        <div className={`${style.UpPage} ${style.page}`} style={{display:"flex"}} id="background" onClick={event => {
                            if (event.target.id == "background") {
                                setInProp(false)
                            }
                        }}>
                            <>
                                {arg.type === "time" &&
                                    <div className={styleUi.view}>
                                        <div className={styleUi.header}>
                                            <YStyle.Span size={17} fontWeight={400}>輸入時間</YStyle.Span>
                                            <YStyle.Span size={17} fontWeight={700} style={{ cursor: "pointer" }} onClick={e => {
                                                console.log(">>", arg.onSelect)
                                                arg.onSelect(data);
                                                setInProp(false);
                                            }}>確定</YStyle.Span>
                                        </div>
                                        <SelectTime onSelect={value => {
                                            setData(value);
                                        }} />
                                    </div>
                                }
                                {arg.type === "option" &&
                                    <div className={styleUi.view}>
                                        <div className={styleUi.header}>
                                            <YStyle.Span size={17} fontWeight={400}>選擇付款人</YStyle.Span>
                                            <YStyle.Span size={17} fontWeight={700} style={{ cursor: "pointer" }} onClick={e => {
                                                arg.onSelect(data);
                                                setInProp(false);
                                            }}>確定</YStyle.Span>
                                        </div>
                                        <SelectOption list={arg.list} dispplayKey={arg.displayKey} onSelect={value => {
                                            setData(value)
                                        }} />
                                    </div>
                                }
                            </>
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition>
        </div>
    );
  
}

export default memo(OptionSelector);